import { UTA_CARD_ISSUANCE_INCHARGE } from "common/constant";
import { isAuthorizedUser } from "./isAuthorizedUser";
import { utilityTunnelDepartments } from "common/enums";

export const getAllowedStatusForUTAApplication = (
  applicationStatus,
  userRoles,
  isEmployee = false,
  departmentId = null
) => {
  const { approvedBy, rejectedBy } = applicationStatus;

  const getHODRoleByDepartmentId =
    utilityTunnelDepartments.find(({ value }) => value === departmentId)
      ?.hodRole ?? [];

  const getManagerRoleByDepartmentId =
    utilityTunnelDepartments.find(({ value }) => value === departmentId)
      ?.managerRoles ?? [];

  // first Level Approval for employee
  if (isAuthorizedUser(userRoles, [UTA_CARD_ISSUANCE_INCHARGE]) && isEmployee) {
    return {
      canApproved: !approvedBy && !rejectedBy,
      canRejected: !approvedBy && !rejectedBy,
    };
  }

  // first Level Approval for contractor
  if (
    isAuthorizedUser(userRoles, getManagerRoleByDepartmentId) &&
    !isEmployee
  ) {
    return {
      canApproved: !approvedBy && !rejectedBy,
      canRejected: !approvedBy && !rejectedBy,
    };
  }

  // second Level Approval for employee & contractor
  if (
    isAuthorizedUser(userRoles, getHODRoleByDepartmentId) &&
    [...getManagerRoleByDepartmentId, UTA_CARD_ISSUANCE_INCHARGE]?.includes(
      approvedBy
    )
  ) {
    return {
      canApproved: true,
      canRejected: true,
    };
  }

  return {
    canApproved: false,
    canRejected: false,
  };
};
